import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Order } from '../types/types';
import dataService from '../data/dataService';
import '../styles/OrderHistory.css';

const OrderHistory: React.FC = () => {
  const [orders, setOrders] = useState<Order[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dataService.getOrders().then(setOrders).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="orders-page"><p>Loading orders...</p></div>;

  return (
    <div className="orders-page">
      <h1>My Orders</h1>
      {orders.length === 0 ? (
        <p>No orders yet. <Link to="/products">Start shopping</Link></p>
      ) : (
        <div className="orders-list">
          {orders.map(order => (
            <Link key={order.id} to={`/orders/${order.id}`} className="order-card">
              <div className="order-card-header">
                <span className="order-id">Order #{order.id}</span>
                <span className={`order-status status-${order.status.toLowerCase()}`}>{order.status}</span>
              </div>
              <div className="order-card-body">
                <span>${order.total.toFixed(2)}</span>
                <span className="order-date">{new Date(order.createdAt).toLocaleDateString()}</span>
                <span>{order.itemCount} item{order.itemCount !== 1 ? 's' : ''}</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default OrderHistory;
